import React from 'react';
import CareerTimeline from 'src/components/resume/CareerTimeline';
import SkillsSection from 'src/components/resume/SkillsSection';

function SectionHeader({ kicker, title, sub }) {
    return (
        <div className="section-header">
            {kicker && <div className="section-kicker">{kicker}</div>}
            <h2>{title}</h2>
            {sub && <p className="section-sub">{sub}</p>}
        </div>
    );
}

export default function EngineerPage() {
    return (
        <div>
            {/* ── Hero ── */}
            <section className="hero-engineer">
                <div className="eng-hero-inner">
                    <div className="eng-hero-grid">
                        {/* Left: copy */}
                        <div className="eng-hero-copy">
                            <div className="eyebrow">Software Engineer · Victoria, Australia</div>
                            <h1 className="hero-name">Matthew Brinkmann</h1>
                            <p className="eng-tagline">
                                Career switcher into Technology who is passionate about building
                                elegant, scalable software solutions. 4+ years of experience
                                crafting exceptional software in enterprise environments.
                            </p>
                            <div className="hero-cta">
                                <a className="link-arrow" href="#career">Career journey →</a>
                                <a className="link-arrow ghost" href="#skills">Technical expertise →</a>
                            </div>
                            <div className="eng-social">
                                <a
                                    href="https://www.linkedin.com/in/matthew-brinkmann/"
                                    className="social-icon"
                                    aria-label="LinkedIn"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    in
                                </a>
                                <a
                                    href="https://github.com/Matthew-brinkmann"
                                    className="social-icon"
                                    aria-label="GitHub"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    gh
                                </a>
                            </div>
                        </div>

                        {/* Right: stats card */}
                        <div className="stats-card">
                            <div className="stats-grid">
                                <div className="stat">
                                    <div className="stat-value">4+</div>
                                    <div className="stat-label">years in software</div>
                                </div>
                                <div className="stat">
                                    <div className="stat-value">2</div>
                                    <div className="stat-label">careers crossed</div>
                                </div>
                                <div className="stat">
                                    <div className="stat-value">10</div>
                                    <div className="stat-label">roles, real-world</div>
                                </div>
                                <div className="stat">
                                    <div className="stat-value">∞</div>
                                    <div className="stat-label">curiosity</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* ── Career Journey ── */}
            <section id="career" className="section">
                <div className="section-inner">
                    <SectionHeader
                        kicker="Timeline"
                        title="Career Journey"
                        sub="From bakery at 5am to shipping software. Click any role for the story."
                    />
                    <CareerTimeline />
                </div>
            </section>

            {/* ── Technical Expertise ── */}
            <section id="skills" className="section">
                <div className="section-inner">
                    <SectionHeader
                        kicker="Stack"
                        title="Technical Expertise"
                        sub="Daily drivers in green. Completed projects with, but not daily, in blue."
                    />
                    <SkillsSection />
                </div>
            </section>
        </div>
    );
}
